import { useEffect, useState } from "react";

const navLinks = [
  { href: '#top', label: '高分榜' },
  { href: '#gems', label: '冷门佳作' },
  { href: '#completed', label: '完结番' },
  { href: '#pick', label: '本周清单' },
  { href: '#review', label: '口碑排行' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-18 items-center justify-between px-4 md:px-6">
        <a
          href="#hero"
          className="flex items-center gap-2 font-heading text-xl md:text-2xl whitespace-nowrap"
          aria-label="小虎看番 - 返回首页"
        >
          <span
            className={`inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 ${scrolled ? '' : 'ring-2 ring-background-50/40'}`}
          >
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className={scrolled ? 'text-foreground-950' : 'text-background-50'}>小虎看番</span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`px-3 py-2 text-sm rounded-full whitespace-nowrap transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-add-line" />
            订阅补番清单
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`inline-flex h-10 w-10 items-center justify-center rounded-full transition-colors md:hidden ${
            scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
          }`}
          aria-label="切换菜单"
          aria-expanded={open}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                <i className="ri-mail-add-line" />
                订阅补番清单
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}